export default class AnswerForm {
  public body: string = ''
  public question_id: string
  public accepted: string
  public materials: File[] = []

  toFormData() {
    const formData = new FormData()

    if (this.materials.length > 0) {
      this.materials.forEach(file => {
        formData.append('materials[]', file)
      })
    }
    if (this.body) {
      formData.append('body', this.body)
    }
    if (this.accepted) {
      formData.append('accepted', this.accepted)
    }
    if (this.question_id) {
      formData.append('question_id', this.question_id)
    }

    return formData
  }
}
